export default __webpack_public_path__ + "static/media/MetaMask_Fox.dabbc866.png";